// import React from 'react';
// import { ChevronLeft, ChevronRight, Star } from 'lucide-react';

// const Testimonials = ({ currentTestimonial }) => {
//   const testimonials = [
//     {
//       name: "Joe C.",
//       quote: "Embarking on a personal training program can be a life-changing decision, and my experience with the Elyte Personal Training Program has been nothing short of remarkable. From the personalized guidance of Olu to the comprehensive approach, this program has pushed me to my limits and helped me achieve my fitness goals. I started my journey in December of 2022 and as of June 2023 I've lost 50lbs!",
//       highlight: "I lost 50lbs in 6 months!"
//     },
//     {
//       name: "Xtina C.",
//       quote: "Olu is extremely professional! He is attentive and listens to his clients wants and needs, then customizes programming accordingly. His training style is unique, and offers a level of responsiveness that is unmatched. I would highly recommend Elyte and Olu to meet and surpass all of your fitness goals!",
//       highlight: "His custom program's results are unmatched!"
//     },
//     {
//       name: "Melissa P.",
//       quote: "Olu has been very encouraging and takes the time to listen and explore all aspects of health and fitness to make the best choices for my goals. He works WITH you and not against you- so if going to a gym isn't your thing, Olu will make your goals happen with what works for you.",
//       highlight: "Olu makes your goals happen by working with you!"
//     },
//     {
//       name: "Temi O.",
//       quote: "Coach Olu is the best! He's very passionate about what he does and it shows! Thank you for all the great tips and motivation.",
//       highlight: "Olu is very passionate about what he does and the results show!"
//     },
//     {
//       name: "Victor O.",
//       quote: "Communication was seamless throughout the entire training process. Olu was always available to answer any questions, provide guidance, and offer valuable insights. He had a deep understanding of exercise science, nutrition, and various training techniques. From the very beginning, he took the time to understand my fitness goals, limitations, and preferences, tailoring a program specifically for me. Would recommend to anyone looking into online fitness coaching!",
//       highlight: "Olu has a very deep understanding of exercise science and nutrition...helped me get the results I wanted"
//     },
//     {
//       name: "Dreah Kay",
//       quote: "Olu is a very caring trainer and he truly caters to your individual needs. He put the focus solely on your goals and what you wish to achieve and he then create the perfect plan for you. He's available to chat when you need him and he never make you feel rushed or unimportant. I'm in Michigan, so I'm miles away from him, But he makes me feel close. Thank you Olu!",
//       highlight: "Olu creates the perfect plan for you to help you get the results you want"
//     },
//     {
//       name: "Naiya",
//       quote: "I started with Elyte a few months back the program helped me keep a routine reset my mindset and Olu is a great coach he helps motivate the mind to have a new start he is so aware of the body and how to reset into a new pattern. Now I am on my own holding the pattern myself and focusing on my goals he really cares about what he does and his passionate help others live a healthy lifestyle certainly rubbed off on me.",
//       highlight: "Olu helped me reset my mindset which helped me create lasting results"
//     },
//     {
//       name: "Faye B.",
//       quote: "Absolutely loved working with Coach Olu! He's patient, answers any questions I throw his way and you can tell he truly cares about his clients and wants so much for us to achieve our goals",
//       highlight: "He wants you to achieve your goals as much as you do!"
//     },
//     {
//       name: "Michelle G.",
//       quote: "I love working with Olu. He is extremely well versed in all aspects of physical fitness. From physical exercises to nutrition. He listens when you speak and asks questions that helps him understand who you are as an individual. By doing so it allows him to come up with a workout plan that perfectly fitted to you and your lifestyle.",
//       highlight: "Olu tailors his program to fit your individual goals and lifestyle"
//     },
//   ];

//   return (
//     <section className="py-16 bg-sky-50" id="success">
//       <div className="max-w-6xl mx-auto px-4">
//         <div className="text-center mb-16">
//           <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
//             What Our <span className="text-sky-600">Clients</span> Say
//           </h2>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//             Real people. Real results.
//           </p>
//         </div>

//         <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 relative">
//           {/* Left navigation arrow */}
//           <button
//             className="absolute left-2 top-1/2 -translate-y-1/2 bg-sky-100 hover:bg-sky-200 p-2 rounded-full text-sky-600 z-10 hidden md:block"
//             onClick={() => {
//               /* Handle previous testimonial */
//             }}
//           >
//             <ChevronLeft size={24} />
//           </button>

//           {/* Current testimonial */}
//           <div className="text-center">
//             <div className="mb-4 flex justify-center">
//               <div className="w-20 h-20 bg-sky-100 rounded-full overflow-hidden flex items-center justify-center">
//                 <div className="text-sky-600 font-bold text-2xl">
//                   {testimonials[currentTestimonial].name.charAt(0)}
//                 </div>
//               </div>
//             </div>
            
//             <div className="flex justify-center mb-4">
//               <div className="flex text-yellow-400">
//                 <Star fill="currentColor" size={20} />
//                 <Star fill="currentColor" size={20} />
//                 <Star fill="currentColor" size={20} />
//                 <Star fill="currentColor" size={20} />
//                 <Star fill="currentColor" size={20} />
//               </div>
//             </div>
            
//             <h3 className="text-2xl font-bold text-sky-600 mb-6">
//               "{testimonials[currentTestimonial].highlight}"
//             </h3>
            
//             <blockquote className="text-gray-700 max-w-3xl mx-auto mb-6">
//               {testimonials[currentTestimonial].quote}
//             </blockquote>
            
//             <div className="font-bold text-gray-900">- {testimonials[currentTestimonial].name}</div>
//           </div>

//           {/* Right navigation arrow */}
//           <button
//             className="absolute right-2 top-1/2 -translate-y-1/2 bg-sky-100 hover:bg-sky-200 p-2 rounded-full text-sky-600 z-10 hidden md:block"
//             onClick={() => {
//               /* Handle next testimonial */
//             }}
//           >
//             <ChevronRight size={24} />
//           </button>
//         </div>

//         {/* Testimonial navigation dots */}
//         <div className="flex justify-center mt-8 space-x-2">
//           {testimonials.map((_, index) => (
//             <button
//               key={index}
//               className={`w-3 h-3 rounded-full ${
//                 index === currentTestimonial ? 'bg-sky-600' : 'bg-sky-200'
//               }`}
//               onClick={() => {
//                 /* Set current testimonial */
//               }}
//             />
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Testimonials;




import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Star, Pause, Play } from 'lucide-react';

const Testimonials = () => {
const [currentIndex, setCurrentIndex] = useState(0);
const [isAutoPlaying, setIsAutoPlaying] = useState(true);
const [touchStart, setTouchStart] = useState(null);
const [touchEnd, setTouchEnd] = useState(null);
const [isMobile, setIsMobile] = useState(false);

// Check if mobile on mount and window resize
useEffect(() => {
const checkIsMobile = () => {
setIsMobile(window.innerWidth < 768);
};

checkIsMobile();
window.addEventListener('resize', checkIsMobile);

return () => window.removeEventListener('resize', checkIsMobile);
}, []);

const testimonials = [
{
name: "Joe C.",
avatar: "/testimonials/joe.webp",
quote: "Embarking on a personal training program can be a life-changing decision, and my experience with the Elyte Personal Training Program has been nothing short of remarkable. From the personalized guidance of Olu to the comprehensive approach, this program has pushed me to my limits and helped me achieve my fitness goals. I started my journey in December of 2022 and as of June 2023 I've lost 50lbs!",
highlight: "I lost 50lbs in 6 months!"
},
{
name: "Xtina C.",
avatar: "/testimonials/xtina.webp",
quote: "Olu is extremely professional! He is attentive and listens to his clients wants and needs, then customizes programming accordingly. His training style is unique, and offers a level of responsiveness that is unmatched. I would highly recommend Elyte and Olu to meet and surpass all of your fitness goals!",
highlight: "His custom program's results are unmatched!"
},
{
name: "Melissa P.",
avatar: "/testimonials/melissa.webp",
quote: "Olu has been very encouraging and takes the time to listen and explore all aspects of health and fitness to make the best choices for my goals. He works WITH you and not against you- so if going to a gym isn't your thing, Olu will make your goals happen with what works for you.",
highlight: "Olu makes your goals happen by working with you!"
},
{
name: "Temi O.",
avatar: "/testimonials/temi.webp",
quote: "Coach Olu is the best! He's very passionate about what he does and it shows! Thank you for all the great tips and motivation.",
highlight: "Olu is very passionate about what he does and the results show!"
},
{
name: "Victor O.",
avatar: "/testimonials/victor.webp",
quote: "Communication was seamless throughout the entire training process. Olu was always available to answer any questions, provide guidance, and offer valuable insights. He had a deep understanding of exercise science, nutrition, and various training techniques. From the very beginning, he took the time to understand my fitness goals, limitations, and preferences, tailoring a program specifically for me. Would recommend to anyone looking into online fitness coaching!",
highlight: "Olu has a very deep understanding of exercise science and nutrition...helped me get the results I wanted"
},
{
name: "Dreah Kay",
avatar: "/testimonials/Dreah.webp",
quote: "Olu is a very caring trainer and he truly caters to your individual needs. He put the focus solely on your goals and what you wish to achieve and he then create the perfect plan for you. He's available to chat when you need him and he never make you feel rushed or unimportant. I'm in Michigan, so I'm miles away from him, But he makes me feel close. Thank you Olu!",
highlight: "Olu creates the perfect plan for you to help you get the results you want"
},
{
name: "Naiya",
avatar: "/testimonials/Naiya.webp",
quote: "I started with Elyte a few months back the program helped me keep a routine reset my mindset and Olu is a great coach he helps motivate the mind to have a new start he is so aware of the body and how to reset into a new pattern. Now I am on my own holding the pattern myself and focusing on my goals he really cares about what he does and his passionate help others live a healthy lifestyle certainly rubbed off on me. I am grateful for the push and the new mind patterns he passed to me looking forward to this new me thanks Olu. I will certainly pass the word about your program to others who are looking for the new them because it works thank you again!",
highlight: "Olu helped me reset my mindset which helped me create lasting results"
},
{
name: "Faye B.",
avatar: "/testimonials/Faye.webp",
quote: "Absolutely loved working with Coach Olu! He's patient, answers any questions I throw his way and you can tell he truly cares about his clients and wants so much for us to achieve our goals",
highlight: "He want's you to achieve your goals as much as you do!"
},
{
name: "Denzel C.",
avatar: "/testimonials/Denzel.webp",
quote: "Olu is an excellent coach, follow his programming and his advice and you will get results. It is really up to you how fast that happens because he provides you with all of the tools. He will provide you with the motivation as well!",
highlight: "Olu provides you with everything you need to reach your goals"
},
{
name: "Michelle G.",
avatar: "/testimonials/Michelle.webp",
quote: "I love working with Olu. He is extremely well versed in all aspects of physical fitness. From physical exercises to nutrition. He listens when you speak and asks questions that helps him understand who you are as an individual. By doing so it allows him to come up with a workout plan that perfectly fitted to you and your lifestyle. He lives and breaths fitness. It's something that excites him and pushes him to keep learning. He is always on your side. Rooting for you. Thank you Olu for doing what you do! You're the best!!",
highlight: "Olu Tailors his program to fit your individual goals and lifestyle"
}
];

// Auto-play functionality
useEffect(() => {
if (isAutoPlaying) {
const timer = setInterval(() => {
setCurrentIndex((prevIndex) => 
prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
);
}, 5000); // Change slide every 5 seconds

return () => clearInterval(timer);
}
}, [isAutoPlaying, testimonials.length]);

const nextSlide = () => {
setCurrentIndex((prevIndex) => 
prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
);
};

const prevSlide = () => {
setCurrentIndex((prevIndex) => 
prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
);
};

const goToSlide = (index) => {
setCurrentIndex(index);
};

const toggleAutoPlay = () => {
setIsAutoPlaying(!isAutoPlaying);
};

// Touch handlers for swipe functionality
const minSwipeDistance = 50;

const onTouchStart = (e) => {
setTouchEnd(null);
setTouchStart(e.targetTouches[0].clientX);
};

const onTouchMove = (e) => {
setTouchEnd(e.targetTouches[0].clientX);
};

const onTouchEnd = () => {
if (!touchStart || !touchEnd) return;

const distance = touchStart - touchEnd;
const isLeftSwipe = distance > minSwipeDistance;
const isRightSwipe = distance < -minSwipeDistance;

if (isLeftSwipe) {
nextSlide();
} else if (isRightSwipe) {
prevSlide();
}
};

return (
<section className="py-16 bg-gradient-to-br from-sky-50 to-blue-50" id="testimonials">
<div className="max-w-7xl mx-auto px-4">
<div className="text-center mb-12">
<h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
What Our <span className="bg-gradient-to-r from-sky-600 to-blue-600 bg-clip-text text-transparent">Clients</span> Say
</h2>
<p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
Real people. Real results. Real transformations.
</p>

{/* Play/Pause Control */}
<div className="flex justify-center items-center gap-4 mb-8">
<button
  onClick={toggleAutoPlay}
  className="flex items-center gap-2 px-4 py-2 bg-white rounded-full shadow-md hover:shadow-lg transition-all duration-300 text-sky-600 border border-sky-200"
>
  {isAutoPlaying ? (
    <>
      <Pause size={16} />
      <span className="text-sm font-medium">Pause</span>
    </>
  ) : (
    <>
      <Play size={16} />
      <span className="text-sm font-medium">Play</span>
    </>
  )}
</button>
</div>
</div>

<div className="relative">
{/* Navigation arrows */}
<button
onClick={prevSlide}
className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg hover:shadow-xl p-3 rounded-full text-sky-600 hover:bg-sky-50 transition-all duration-300 hidden md:flex items-center justify-center"
>
<ChevronLeft size={24} />
</button>

<button
onClick={nextSlide}
className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg hover:shadow-xl p-3 rounded-full text-sky-600 hover:bg-sky-50 transition-all duration-300 hidden md:flex items-center justify-center"
>
<ChevronRight size={24} />
</button>

{/* Testimonial Cards Container */}
<div 
className="overflow-hidden"
onTouchStart={onTouchStart}
onTouchMove={onTouchMove}
onTouchEnd={onTouchEnd}
>
<div 
  className="flex transition-transform duration-500 ease-in-out"
  style={{ 
    transform: `translateX(-${currentIndex * (isMobile ? 80 : 100/3)}%)`,
  }}
>
  {testimonials.map((testimonial, index) => (
    <div
      key={index}
      className="w-4/5 md:w-1/3 flex-shrink-0 px-2"
    >
      <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6 md:p-8 h-full flex flex-col transform hover:-translate-y-1">
        {/* Stars */}
        <div className="flex justify-center mb-4">
          <div className="flex text-yellow-400">
            {[...Array(5)].map((_, i) => (
              <Star key={i} fill="currentColor" size={16} className="md:w-[18px] md:h-[18px]" />
            ))}
          </div>
        </div>

        {/* Avatar */}
        <div className="flex justify-center mb-4 md:mb-6">
          <img 
            src={testimonial.avatar} 
            alt={testimonial.name}
            className="w-16 h-16 md:w-20 md:h-20 rounded-full object-cover ring-4 ring-sky-100 shadow-lg"
          />
        </div>
        
        {/* Highlight Quote */}
        <h3 className="text-base md:text-lg font-bold text-sky-600 mb-3 md:mb-4 text-center leading-tight">
          "{testimonial.highlight}"
        </h3>
        
        {/* Full Quote */}
        <blockquote className="text-gray-600 text-sm leading-relaxed mb-4 md:mb-6 flex-grow">
          "{testimonial.quote}"
        </blockquote>
        
        {/* Name */}
        <div className="text-center">
          <div className="font-bold text-gray-900 md:text-lg">
            {testimonial.name}
          </div>
        </div>
      </div>
    </div>
  ))}
</div>
</div>

{/* Mobile Carousel - Show one card at 80% width */}
<div className="md:hidden">

</div>
</div>

{/* Dots Navigation */}
<div className="flex justify-center mt-8 space-x-2">
{testimonials.map((_, index) => (
<button
  key={index}
  onClick={() => goToSlide(index)}
  className={`w-3 h-3 rounded-full transition-all duration-300 ${
    index === currentIndex 
      ? 'bg-sky-600 w-8' 
      : 'bg-sky-200 hover:bg-sky-300'
  }`}
/>
))}
</div>

{/* Mobile Navigation Buttons */}
<div className="flex justify-center mt-6 gap-4 md:hidden">
<button
onClick={prevSlide}
className="bg-white shadow-lg p-3 rounded-full text-sky-600 hover:bg-sky-50 transition-all duration-300"
>
<ChevronLeft size={20} />
</button>
<button
onClick={nextSlide}
className="bg-white shadow-lg p-3 rounded-full text-sky-600 hover:bg-sky-50 transition-all duration-300"
>
<ChevronRight size={20} />
</button>
</div>
</div>
</section>
);
};

export default Testimonials;